<template>
  <div>
    <v-btn
      rounded="pill"
      class="bookmark-btn"
      :disabled="!playlistProductData"
      @click="playlistModalOpen = true"
    >
      <v-icon class="bookmark-icon">fa-light fa-bookmark</v-icon>
      <span class="bookmark-text d-none d-md-inline">Pievienot izlasei</span>
    </v-btn>
    <UserPlaylistsModal
      v-if="playlistProductData"
      :dialog-value="playlistModalOpen"
      :product-data="playlistProductData"
      @close="playlistModalOpen = false"
    />
  </div>
</template>

<script lang="ts">
import { usePdfStore } from "~/stores/pdfStore"

type PlaylistTarget =
  | { type: "WorksheetFile"; identifier: number }
  | { type: "Product"; identifier: string }

export default {
  setup() {
    const pdfStore = usePdfStore()
    return { pdfStore }
  },

  data() {
    return {
      playlistModalOpen: false,
    }
  },

  computed: {
    playlistProductData(): PlaylistTarget | null {
      const hasWorksheetQuery = Boolean(this.$route.query.w)
      const currentFile = this.pdfStore.currentFile
      const worksheet = currentFile?.worksheet_file
      const isLoading = (this.pdfStore as any).isLoading ?? false

      if (hasWorksheetQuery) {
        if (worksheet?.id) {
          return { identifier: worksheet.id, type: "WorksheetFile" }
        }
        if (isLoading) {
          return null
        }
        return null
      }

      const product = currentFile?.product
      if (product?.slug) {
        return { identifier: product.slug, type: "Product" }
      }

      return null
    },
  },
}
</script>
